import { MeasurementUnit } from '@shure/shared/angular/data-access/system-api/models';

const unitRoundPrecision: Record<MeasurementUnit, number> = {
	Feet: 10,
	Meters: 100
};

/**
 * Round the given number based a precision what the unit is associated with
 *  - Feet: 1 / 10 (1 decimal point)
 *  - Meter: 1 / 100 (2 decimal point)
 * @param x number to be rounded
 * @param measurementUnit measurement unit what the x is associated with
 * @returns the rounded number
 */
export function unitBasedRound(x: number, measurementUnit: MeasurementUnit): number {
	const precision = unitRoundPrecision[measurementUnit];
	return Math.round(x * precision) / precision;
}
